// Function to select random array element
function bubbleRandomValue(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

function bubble_motion() {

    if (!$('.ap_bubble_wrap').length) { return; }

    var focus_flag = true;

    var sArray = [20, 25, 28, 30]; // size
    var xArray = [3, 7, 8, 15, 20]; // x motion
    var tArray = [4.5, 5, 5.5, 6]; // speed

    tArray = [6, 10, 12, 17];

    // small screen size
    //if(AP.is_screen(600)){ sArray = [2,3,4,5]; }

    $('.ap_bubble_wrap').each(function () {

        var $this = $(this);
        var lArray = []; // position

        // Push the header width values to lArray
        for (var i = 0; i < $this.width(); i++) { lArray.push(i); }

        // design story and scent
        if ($this.hasClass('design_story_visual_bubble_wrap')) {
            sArray = [4, 5, 6];
            xArray = [3, 5, 7];
            tArray = [15, 20, 25, 30];

            if (AP.is_screen(600)) { sArray = [1, 2, 3]; }
        }

        setInterval(function () {
            if (focus_flag) {
                var size = bubbleRandomValue(sArray);
                var speed = bubbleRandomValue(tArray);

                $this.append('<div class="ap_bubble" style="left: ' + bubbleRandomValue(lArray) + 'px; width: ' + size + 'px; height:' + size + 'px; opacity: 0;"></div>');

                var $bubble = $this.find('.ap_bubble').last();

                TweenMax.fromTo($bubble, 0.3, { autoAlpha: 0, scale: 0 }, { autoAlpha: 1, scale: 1, force3D: true, ease: Power0.easeNone });
                TweenMax.to($bubble, 0.8, { x: bubbleRandomValue(xArray), yoyo: true, repeat: -1, force3D: true, ease: Power1.easeInOut });
                TweenMax.fromTo($bubble, speed, { y: $this.outerHeight() }, { y: 0, force3D: true, ease: Power1.easeInOut, onComplete: function () { $bubble.remove(); } });
                TweenMax.to($bubble, speed + 0.5, { scale: 0, force3D: true, delay: .3, ease: Power1.easeInOut });
            }
        }, $this.data('interval'));

    });

    // focus check
    $(window).on("blur focus", function (e) {
        var prevType = $(this).data("prevType");

        if (prevType != e.type) { //  reduce double fire issues
            switch (e.type) {
                case "blur":
                    focus_flag = false;
                    break;
                case "focus":
                    focus_flag = true;
                    break;
            }
        }

        $(this).data("prevType", e.type);
    });

}
bubble_motion();

window.onload = function () {
    $('.load01_as').removeClass('load01_as').addClass('load01_to');
    $('.load02_as').removeClass('load02_as').addClass('load02_to');
    $('.load03_as').removeClass('load03_as').addClass('load03_to');
    setTimeout(function () {
        scrollTo(0, 0);

    }, 100);
}
$(document).ready(function () {
    AOS.init();

    $('.walter-friends-wallpaper .pc_only .slick-wrapper').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        draggable: true
    });

    $('.walter-friends-wallpaper .mo_only .slick-wrapper').on('init', function (event, slick) {
        $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
        $('.current').text(slick.currentSlide + 1);
        $('.total').text(slick.slideCount);
    })
        .slick({
            slidesToScroll: 1,
            infinite: false,
            arrows: true
        })
        .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.current').text(nextSlide + 1);
        });

    $('.popup-slick-container .slick-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        draggable: true
    });

    var moreBtn;
    $('.walter-friends-wallpaper .more-btn').on('click', function (e) {
        e.preventDefault();
        var slideNum = $(this).data('slide');
        $('body').css({ position: 'relative', overflow: 'hidden' });
        $('.wallpaper-popup-wrap').addClass('active');
        $('.wallpaper-popup_box').focus();
        $('.popup-slick-container .slick-wrapper').resize();
        $('.popup-slick-container .slick-wrapper').slick('slickGoTo', slideNum);
        moreBtn = $(this);
    });
    $('.wallpaper-popup-wrap .popup-close').on('click', function () {
        $('.wallpaper-popup-wrap').removeClass('active');
        $('body').css({ position: 'static', overflow: 'visible' });
        moreBtn.focus();
    });


    var clickEvent = (function () {
        if ('ontouchstart' in document.documentElement === true) {
            return 'touchstart';
        } else {
            return 'click';
        }
    })();

    $('.detail-btn').on(clickEvent, function () {
        var thisParent = $(this).parents('.f-detail'),
            thisParentImg = $(this).parents('.friends');
        if (thisParent.hasClass('open')) {
            thisParent.removeClass('open');
            thisParentImg.removeClass('active');
        } else {
            thisParent.addClass('open');
            if (!thisParentImg.hasClass('active')) {
                thisParentImg.addClass('active');
            }
        }
    });

});